import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const WhyChooseMoweb = () => {
    return (
        <div className="section-py">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Choose Moweb?
                        </h2>
                        <p className="mb-3">
                            When your supply chain is the backbone of your business, you need more than just developers. You need
                            a strategic technology partner who understands logistics, builds with precision, and delivers at
                            scale.
                        </p>
                        <p
                            className="text-textcolor mb-0 fw-700 fs-lg"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Here&apos;s why businesses choose Moweb:
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 mb-10">
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/moweb-supply-chain-icons/ic-build-for-complex.svg"
                                width={36}
                                height={36}
                                alt="build-for-complex"
                                loading="lazy"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Built for Complex Supply Chains</p>
                        <p className="fs-md mb-0">
                            From multi-warehouse inventory systems to global freight tracking, we specialize in solving
                            high-stakes supply chain challenges with custom-built platforms that perform under pressure.
                        </p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/moweb-supply-chain-icons/ic-proven-impact.svg"
                                width={36}
                                height={36}
                                alt="proven-impact"
                                loading="lazy"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Proven Impact, Real ROI</p>
                        <p className="fs-md mb-0">
                            Clients have reduced inventory costs by up to 37%, improved order accuracy by 99%, and accelerated
                            deliveries by over 60% using our solutions. We don&apos;t just build—we move the needle.
                        </p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/moweb-supply-chain-icons/ic-speed.svg"
                                width={36}
                                height={36}
                                alt="Speed, Without Compromise"
                                loading="lazy"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Speed, Without Compromise</p>
                        <p className="fs-md mb-0">
                            Our agile approach means faster launches and fewer bottlenecks. You get enterprise-grade software in
                            weeks, not months—without sacrificing quality or scalability.
                        </p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/moweb-supply-chain-icons/ic-end-to-end.svg"
                                width={36}
                                height={36}
                                alt="End-to-End Partnership"
                                loading="lazy"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">End-to-End Partnership</p>
                        <p className="fs-md mb-0">
                            From initial discovery to post-launch optimization, we stay with you every step of the way. Expect
                            hands-on support, ongoing enhancements, and a partner who treats your business like their own.
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10">
                        <h2 className="mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Let&apos;s Engineer a Supply Chain That Scales
                        </h2>
                        <p className="mb-3">Work with a team that delivers software and results.</p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Talk to a Supply Chain Expert'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyChooseMoweb;
